package ru.villawonka.app.domain.usecase

import ru.villawonka.app.domain.model.CountryDomain

class GetAvailableCountriesUseCase {

    operator fun invoke(): List<CountryDomain> = listOf(
        CountryDomain.VIETNAM,
        CountryDomain.THAILAND,
        CountryDomain.INDONESIA
    )
}